export default __webpack_public_path__ + "static/media/new_logo_course.e75acf94.svg";